"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    EMAIL: 'notification-type-email',
    SMS: 'notification-type-sms',
    PUSH_NOTIFICATION: 'notification-type-pn',
};
//# sourceMappingURL=notificationTypes.js.map